@if (verfuegung | async; as _verfuegung) {
	<schir-int-client-aufgaben-in-verfuegung [verfuegung]="_verfuegung"
	                                         class="x-section__container" data-test-id="aufgaben-in-verfuegung"
	                                         data-help-anchor="_spalte_aufgaben"/>
}
